import React,{useEffect,useState} from 'react';
import { Container } from 'reactstrap';
import TopTitle from './TopTitle';
import { instance } from './common';
import { Link } from 'react-router-dom';

function List({u_id,u_type,rl,radioPostion,setRep}) {
    let field;
    if(u_type === '일반고객' || u_type === '클라이언트' || u_type === '총판' || u_type === '시공지점'){
        field = 'c.co_user_id';
    }else if(u_type === '카마스터'){
        field = 'c.co_user_id2';
    }
    const [data, setData] = useState([]);
    let obj = {
        u_id:u_id,
        field:field,
    }
    useEffect(() => {
        
      const fetchData = async () => {
        instance.post('/rep_car/rep_new',obj).then(function(res){
            setData(res.data);
        });
        
      };

      fetchData();

    }, []);

    console.log('data : ', data)
    if(data.length == 0){
        setRep(false);
    }else{
        setRep(true);
    }

    const w60 = {
        width:'60%'
    }

    console.log('represent on pc');
    return (
        <>
        {
            data.map((v)=> 
            <div className="pl-0 col-10" style={rl} key={v.rep_id}>
                <h4 className="font-weight-bold">{v.u_car_name}</h4>
                <table className="table non-border-table">
                    <thead></thead>
                    <tbody>
                        <tr>
                            <td className="text-lightgray pl-0 pb-0" style={w60}>년식</td>
                            <td className="pb-0">{v.u_car_age}</td>
                        </tr>
                        <tr>
                            <td className="text-lightgray pl-0 pb-0">출고일</td>
                            <td className="pb-0">{v.u_car_date}</td>
                        </tr>
                        <tr>
                            <td className="text-lightgray pl-0 pb-0">차량번호</td>
                            <td className="pb-0">
                                {
                                u_type == '일반고객'
                                ?v.u_car_number
                                :<span>-</span>
                                }
                            </td>
                        </tr>
                        <tr>
                            <td className="text-lightgray pl-0 pb-0">차량APP등록일</td>
                            <td className="pb-0">{v.u_app_date}</td>
                        </tr>
                        <tr>
                            <td className="text-lightgray pl-0 pb-0">출고색상</td>
                            <td className="pb-0">{v.u_car_color}</td>
                        </tr>
                    </tbody>
                    <tfoot></tfoot>
                </table>
                {
                    u_type == "일반고객" 
                    ? v.represent == 1 
                        ? <input type="radio" name="repre_car" data-id={v.rep_id} style={radioPostion} checked/>
                        :<input type="radio" name="repre_car" data-id={v.rep_id} style={radioPostion}/>
                    : v.represent2 == 1
                        ? <input type="radio" name="repre_car" data-id={v.rep_id} style={radioPostion} checked/>
                        :<input type="radio" name="repre_car" data-id={v.rep_id} style={radioPostion}/>
                }
            </div>
            )
        }
        {data.length === 0 && 
            <p className="text-center w-100" style={{ fontWeight: "normal", fontSize: "24px", height: "400px", display: "flex", flexDirection: "column", justifyContent: "center" }}>!!대표 차량이 없습니다!!</p>
        }
        </>
        
    );
}

function allremove(u_login_id,u_type){
    let obj;
    let whereField;
    if(u_type == '일반고객'){
        obj = {represent:0}
        whereField ='u_id';
    }else if(u_type == '카마스터'){
        obj = {represent2:0}
        whereField ='u_id2';
    }
    
    let valueObj = {
        obj:obj,
        whereField:whereField,
        whereValue:u_login_id
    }



    const fetchData = async () => {
        instance.post('/rep_car/update',valueObj).then(function(res){
            var size = document.getElementsByName("repre_car").length;
    
            for(var i = 0; i < size; i++){
                if(document.getElementsByName("repre_car")[i].checked == true){
                    let obj;
                    if(u_type == '일반고객'){
                        obj = {represent:1}
                    }else if(u_type == '카마스터'){
                        obj = {represent2:1}
                    }
                    let valueObj = {
                        obj:obj,
                        whereField:'rep_id',
                        whereValue:document.getElementsByName("repre_car")[i].dataset.id
                    }
                    const fetchData = async () => {
                        instance.post('/rep_car/update',valueObj).then(function(res){
                            alert('대표차량이 변경되었습니다.');
                        });
                        
                    };
                
                    fetchData();
                }
            }
        });
        
    };

    fetchData();
}


function Represent(){
    
    const session = JSON.parse(window.sessionStorage.result);
    const {u_login_id,u_type} = session;

    const [isRep ,setRep] = useState(false);

    const relative = {
        position:'relative',
        borderBottom: '2px solid black',
        paddingBottom: '7px'
    }
    const rl = {
        position:'relative'
    }
    const position = {
        position: 'absolute',
        right:'0',
        top:'-4px'
    }

    const radioPostion = {
        position: 'absolute',
        right: '-30px',
        top: '50%',
        transform: 'translate(-50%)',
    }

    const setRepre = () => {
        if(isRep){
            allremove(u_login_id,u_type);

        }else{
            alert('차량이 존재하지 않습니다.');
        }

    }

    return (
        <Container>
            <TopTitle title='대표 차량 관리' />
            <div className="row">
                <div className="w-100 mb-4" style={relative}>
                    <h3 className="font-weight-bold m-0">차량 리스트</h3>
                    <div style={position}>
                        <span className="btn btn-primary mr-2 " onClick={setRepre}>대표차량 설정</span>
                        <Link to='/insertCar'><span className="btn btn-primary">차량 추가</span></Link>
                    </div>
                </div>
                <List 
                u_id={u_login_id}
                u_type={u_type}
                rl={rl} 
                radioPostion={radioPostion}
                setRep={setRep}
                />   
            </div>
        </Container>     
    )

}


export default Represent;